import * as React from 'react'
import { FLOATING_BODY_PATH, prefetchMascotModel } from '@repo/studio-features-3d-mascot/prefetch'
import type { AidaPresentationMode } from '../../stores/overlay-store'
import { getAidaMascotModelUrl } from '../../utils/lfs-url'

export function useChatPortal(open: boolean) {
  const [keepChat, setKeepChat] = React.useState(false)
  const [park, setPark] = React.useState<HTMLDivElement | null>(null)
  const [fullscreenSlot, setFullscreenSlot] = React.useState<HTMLDivElement | null>(null)
  const [detachedSlot, setDetachedSlot] = React.useState<HTMLDivElement | null>(null)

  React.useEffect(() => {
    if (open) {
      setKeepChat(true)
      void prefetchMascotModel(getAidaMascotModelUrl(FLOATING_BODY_PATH)).catch(() => {
        // The mascot reports this once Three.js is ready to parse the file.
      })
    }
  }, [open])

  return {
    keepChat,
    park,
    setPark,
    fullscreenSlot,
    setFullscreenSlot,
    detachedSlot,
    setDetachedSlot,
  }
}

export function resolveChatHost({
  open,
  mode,
  fullscreenSlot,
  detachedSlot,
  park,
  showOpenShell,
  pipSlot = null,
}: {
  open: boolean
  mode: AidaPresentationMode
  fullscreenSlot: HTMLDivElement | null
  detachedSlot: HTMLDivElement | null
  park: HTMLDivElement | null
  showOpenShell: boolean
  pipSlot?: HTMLDivElement | null
}) {
  if (pipSlot) {
    return pipSlot
  }
  if (!open) {
    return park
  }
  if (mode === 'fullscreen') {
    if (fullscreenSlot && !showOpenShell) {
      return fullscreenSlot
    }
    return park
  }
  if (detachedSlot) {
    return detachedSlot
  }
  return park
}
